import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class NlrFieldRecordFomerTenureModalDataService {
    private formerTenures = new BehaviorSubject<any>([]);
    private parentPlanType = new BehaviorSubject<any>([]);

    getFormerTenures(): Observable<any> {
        return this.formerTenures;
    }

    getParentPlanTypes(): Observable<any> {
        return this.parentPlanType;
    }

    updateFormerTenures(newData: any) {
        this.formerTenures.next(newData);
    }

    updateParentType(newData: any) {
        this.parentPlanType.next(newData);
    }

    saveFormerTenures(newData: any) {
        this.formerTenures.next(newData);
    }
}
